/* Lianne: Strickset-Finder (Überarbeitung nach der Befragung vom 07.10.2026; Entwurf im Klickdummy).
   Für Unentschlossene, als eigener Raum: Ebene über der Seite mit höchstens fünf Fragen. Jede Antwort setzt
   den zugehörigen Shopify-Filter und lädt das Raster über lianne-filterleiste.js nach; die Fragen stammen aus der
   unsichtbaren Vorlage in snippets/lianne-finder.liquid (mit den Trefferzahlen aus results.filters).
   Ergebnis ist das normale Raster; darüber „Deine Auswahl“ als Knöpfe – jeder öffnet nur seine Frage, die
   Optionen richten sich dann nur nach den Antworten davor. Passt danach eine spätere Antwort nicht mehr, fällt
   (möglichst nur) diese mit Hinweis weg. Normale Filter liegen bei aktiver Auswahl hinter „Weitere Filter“.
   Zustand je Kollektion in sessionStorage; gemerkte Farbwelt über assets/lianne-farbwelten.js.
   Seit 27.10.2026 auch der Wolle-Finder (snippets/lianne-wolle-finder.liquid): Die Vorlage nennt ihre Fragen
   (data-reihe) und Wörter (data-wort); ohne diese Angaben gilt die Reihe der Stricksets. */
(function () {
  if (window.__lianneFinder) return;
  window.__lianneFinder = true;

  var REIHE_SETS = ['wer', 'was', 'gr', 'sw', 'welt'];
  var REIHE = REIHE_SETS;
  var KLEID = ['Sweater', 'Cardigan', 'T-Shirt', 'Bluse', 'Kleid', 'Slipover'];
  var GEF = 'filter.p.m.custom.finder_gefuehl';
  var WELT = 'filter.p.m.custom.finder_farbwelt';
  var FW = window.LianneFarbwelt;
  // Finder-Symbol (wie snippets/lianne-finder-symbol.liquid)
  var SYMBOL = '<svg class="lfd-sym" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14.6 19.8C11.2 22 5.4 20.8 4.2 16C3 11.2 6.4 7.8 10.2 7.8C14.4 7.8 17.4 11.2 16.8 15C16.3 18.2 13.6 20.4 10.8 20.6"/><path d="M5 12.4C8.6 12.4 12.2 15.2 13.2 20.4"/><path d="M7.6 8.8C11.2 10.2 14.6 13.4 16 17.4"/><path d="M18.6 3.8C17.9 3 16.5 3.1 16.2 4.4C15.9 5.8 17 7.2 18.4 7.1C19.9 7 21.2 5.6 21.5 4.2C21.8 2.8 20.9 1.9 19.9 2.1C19.4 2.2 19 2.7 18.6 3.8Z" fill="currentColor" stroke-width="1"/></svg>';

  function zKey() { return 'lfd:' + location.pathname; }
  function lesen() { try { return JSON.parse(sessionStorage.getItem(zKey())) || {}; } catch (e) { return {}; } }
  function merken(z) { try { sessionStorage.setItem(zKey(), JSON.stringify(z)); } catch (e) {} }
  function params(u) { return new URL(u || location.href, location.origin).searchParams; }
  function vorlage(wurzel) { return (wurzel || document).querySelector('[data-lfd-vorlage]'); }
  function schritt(v, k) { return v && v.querySelector('[data-schritt="' + k + '"]'); }
  function kacheln(s) { return [].slice.call(s.querySelectorAll('.lfdl-o')); }
  function mitTreffern(s) { return kacheln(s).filter(function (b) { return +b.getAttribute('data-n') > 0 || b.classList.contains('is-on'); }); }
  function gridId() { var f = document.querySelector('[data-lianne-filterleiste]'); var s = f && f.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null; }
  function laden(url) { if (window.lianneFilterLaden) window.lianneFilterLaden(url); else location.href = url; }
  function urlOhne(u, ps) { var x = new URL(u, location.origin); ps.forEach(function (p) { x.searchParams.delete(p); }); x.searchParams.delete('page'); return x.pathname + x.search; }
  function paramVon(k) { var s = schritt(vorlage(), k); return s && s.dataset.param; }
  // Fragen und Wörter der Vorlage (Strickset- oder Wolle-Finder)
  function reiheVon(v) { var r = v && v.getAttribute('data-reihe'); return r ? r.split(',') : REIHE_SETS; }
  function wort(n) { var v = vorlage(), w = ((v && v.getAttribute('data-wort')) || 'Set|Sets').split('|'); return n === 1 ? w[0] : w[1]; }

  // Welche Fragen gestellt werden: mindestens zwei Antworten mit Treffern (oder schon beantwortet);
  // Größe nur bei Kleidungsstücken für Erwachsene (sonst fielen Mützen, Schals usw. heraus)
  function fragen(v, p) {
    p = p || params();
    var S = REIHE.map(function (k) { return schritt(v, k); }).filter(function (s) {
      return s && (mitTreffern(s).length > 1 || p.getAll(s.dataset.param).length);
    });
    var finde = function (k) { return S.filter(function (s) { return s.dataset.schritt === k; })[0]; };
    var was = finde('was'), gr = finde('gr'), wer = finde('wer');
    if (gr && !p.getAll(gr.dataset.param).length) {
      var kleid = !was || p.getAll(was.dataset.param).some(function (x) { return KLEID.indexOf(x) >= 0; });
      var kinder = wer && p.getAll(wer.dataset.param).length && p.getAll(wer.dataset.param).every(function (x) { return x === 'Kinder' || x === 'Baby'; });
      if (!kleid || kinder) S.splice(S.indexOf(gr), 1);
    }
    return S;
  }
  function beantwortet(s, z) { return params().getAll(s.dataset.param).length > 0 || (z.weiter || []).indexOf(s.dataset.schritt) >= 0; }
  function nameVon(k, v) {
    var s = schritt(v || vorlage(), k); if (!s) return k;
    return kacheln(s).filter(function (b) { return b.classList.contains('is-on'); }).map(function (b) { return b.querySelector('b').textContent; }).join(', ') ||
      params().getAll(s.dataset.param).filter(function (x) { return x !== 'Unisex'; }).join(', ') || 'Für alle';
  }

  /* ── Die Ebene ── */
  var ebene = null;
  function ebeneBauen() {
    if (ebene) return ebene;
    ebene = document.createElement('div');
    ebene.className = 'lfdl'; ebene.hidden = true;
    ebene.setAttribute('role', 'dialog'); ebene.setAttribute('aria-modal', 'true'); ebene.setAttribute('aria-labelledby', 'lfdl-q');
    // Am Desktop eine Karte über der abgedunkelten Seite, am Handy Vollbild (assets/lianne-kollektion.css)
    ebene.innerHTML = '<div class="lfdl-box"><div class="lfdl-kopf"><button type="button" class="lfdl-k" data-lfdl-zurueck>← Zurück</button><span class="lfdl-n"></span>' +
      '<button type="button" class="lfdl-k lfdl-x" data-lfdl-zu aria-label="Schließen"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6.4C8.8 8.6 11.6 11.2 13.8 13.6C15.4 15.4 16.8 17 17.6 18.2"/><path d="M17.8 5.8C15.2 7.8 12.6 10.6 10.4 13C8.8 14.8 7.2 16.4 6 17.8C5.8 18.1 6 18.4 6.4 18.2"/></svg></button></div><div class="lfdl-in"></div></div>';
    document.body.appendChild(ebene);
    return ebene;
  }
  // Ein- und Ausblenden mit Übergang (bei reduzierter Bewegung sofort)
  var zuTimer = null;
  function oeffnen() {
    var e = ebeneBauen(); clearTimeout(zuTimer);
    if (!e.hidden && e.classList.contains('is-auf')) return false;
    // Breite des Scrollbalkens ausgleichen – sonst rutscht die Seite beim Sperren des Scrollens nach rechts
    document.documentElement.style.setProperty('--lfd-sb', Math.max(0, window.innerWidth - document.documentElement.clientWidth) + 'px');
    e.hidden = false; document.documentElement.classList.add('lfd-offen');
    requestAnimationFrame(function () { requestAnimationFrame(function () { e.classList.add('is-auf'); }); });
    return true;
  }
  function schliessen() {
    document.documentElement.classList.remove('lfd-offen');
    if (!ebene || ebene.hidden) return;
    ebene.classList.remove('is-auf');
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    clearTimeout(zuTimer); zuTimer = setTimeout(function () { ebene.hidden = true; }, ruhig ? 0 : 240);
    letzteNr = -1;
  }
  var letzteNr = -1;
  function zeigen(s, nr, gesamt, nur, z) {
    var e = ebeneBauen(), inhalt = e.querySelector('.lfdl-in'), mehr = s.hasAttribute('data-mehr');
    var wahl = z.wahl || [];
    var opts = mitTreffern(s).filter(function (b) { return !b.hasAttribute('data-alle') || +b.getAttribute('data-n') > 0; }).map(function (b, i) {
      var c = b.cloneNode(true);
      c.style.setProperty('--i', Math.min(i, 8)); // Kacheln erscheinen kurz nacheinander
      if (mehr) { var an = wahl.indexOf(b.getAttribute('data-werte')) >= 0; c.classList.toggle('is-on', an); c.setAttribute('aria-pressed', an ? 'true' : 'false'); }
      return c.outerHTML;
    }).join('');
    var weiss = s.hasAttribute('data-ohne-weiss') ? '' : '<button type="button" class="lfdl-o lfdl-o--weiss" data-weiss><b>' + (s.getAttribute('data-weiss') || 'Weiß ich noch nicht') + '</b></button>';
    var extras = [].slice.call(s.querySelectorAll('[data-extra]')).filter(function (x) { return +x.getAttribute('data-n') > 0 || x.querySelector('input').checked; });
    var n = 0; if (mehr) kacheln(s).forEach(function (b) { if (wahl.indexOf(b.getAttribute('data-werte')) >= 0) n += +b.getAttribute('data-n'); });
    inhalt.innerHTML = '<h2 id="lfdl-q" tabindex="-1">' + s.getAttribute('data-frage') + '</h2>' +
      (s.getAttribute('data-hilfe') ? '<p class="lfdl-hilfe">' + s.getAttribute('data-hilfe') + '</p>' : '') +
      '<div class="lfdl-opts' + (s.hasAttribute('data-klein') ? ' lfdl-opts--klein' : '') + (mehr ? ' lfdl-opts--bild' : '') + '">' + opts + weiss + '</div>' +
      (extras.length ? '<div class="lfdl-extra"><span>Außerdem wichtig:</span>' + extras.map(function (x) { return x.outerHTML; }).join('') + '</div>' : '') +
      (mehr && wahl.length ? '<div class="lfdl-weiter"><button type="button" class="button" data-lfdl-weiter>Weiter · ' + n + ' ' + wort(n) + '</button></div>' : '');
    inhalt.setAttribute('data-schritt', s.dataset.schritt);
    inhalt.setAttribute('data-param', s.dataset.param);
    e.querySelector('.lfdl-n').innerHTML = SYMBOL + (nur ? 'Antwort ändern' : (nr + 1) + ' von ' + gesamt);
    e.querySelector('[data-lfdl-zurueck]').style.visibility = nr > 0 && !nur ? 'visible' : 'hidden';
    var neu = oeffnen(); e.classList.remove('is-laedt');
    if (inhalt.getAttribute('data-zuletzt') !== s.dataset.schritt || neu) {
      // Richtung: vorwärts gleitet von rechts herein, „Zurück“ von links
      var rueck = !nur && letzteNr >= 0 && nr < letzteNr;
      inhalt.classList.remove('lfdl-in--vor', 'lfdl-in--rueck'); void inhalt.offsetWidth;
      inhalt.classList.add(rueck ? 'lfdl-in--rueck' : 'lfdl-in--vor');
      var box = e.querySelector('.lfdl-box'); if (box) box.scrollTop = 0; e.scrollTop = 0;
    }
    inhalt.setAttribute('data-zuletzt', s.dataset.schritt);
    letzteNr = nur ? -1 : nr;
    var h = inhalt.querySelector('#lfdl-q'); if (h && (neu || !e.contains(document.activeElement))) h.focus({ preventScroll: true });
  }

  // Mehrfachauswahl („Was möchtest Du stricken?“) im offenen Schritt aktualisieren, ohne die Kacheln neu zu bauen
  function wahlZeigen(inhalt, wahl) {
    var n = 0;
    [].forEach.call(inhalt.querySelectorAll('.lfdl-opts--bild .lfdl-o:not([data-weiss])'), function (c) {
      var an = wahl.indexOf(c.getAttribute('data-werte')) >= 0;
      c.classList.toggle('is-on', an); c.setAttribute('aria-pressed', an ? 'true' : 'false');
      if (an) n += +c.getAttribute('data-n');
    });
    var w = inhalt.querySelector('.lfdl-weiter');
    if (!wahl.length) { if (w) w.remove(); return; }
    if (!w) { w = document.createElement('div'); w.className = 'lfdl-weiter'; inhalt.appendChild(w); }
    w.innerHTML = '<button type="button" class="button" data-lfdl-weiter>Weiter · ' + n + ' ' + wort(n) + '</button>';
  }

  /* ── Cookie-Banner zuerst (Testbericht 08.10.2026) ──
     Shopifys Banner liegt über allem und würde den Finder verdecken, das Theme-Banner läge darunter.
     Solange eins offen ist, wartet der Finder und öffnet sich, sobald es beantwortet ist. */
  function bannerOffen() {
    var els = [document.getElementById('shopify-pc__banner'), document.querySelector('.cookie-banner.is-active')];
    return els.some(function (el) {
      if (!el) return false;
      var r = el.getBoundingClientRect(), st = getComputedStyle(el);
      return st.display !== 'none' && st.visibility !== 'hidden' && r.height > 0;
    });
  }
  var bannerTimer = null, bannerHinweis = null;
  function aufBannerWarten() {
    if (!bannerHinweis) {
      bannerHinweis = document.createElement('p');
      bannerHinweis.className = 'lfd-banner-hinweis'; bannerHinweis.setAttribute('role', 'status');
      bannerHinweis.textContent = 'Beantworte bitte zuerst kurz die Cookie-Frage, dann geht es mit dem Finder los.';
      document.body.appendChild(bannerHinweis);
    }
    if (bannerTimer) return;
    bannerTimer = setInterval(function () {
      if (bannerOffen()) return;
      clearInterval(bannerTimer); bannerTimer = null;
      if (bannerHinweis) { bannerHinweis.remove(); bannerHinweis = null; }
      zeichnen();
    }, 400);
  }

  /* ── Vorauswahl über den Link (B4, für Pins und Stories) ──
     ?finder=1&wer=damen&was=cardigan,muetze&gr=m&sw=anfang&welt=warm
     Vorgewählte Fragen werden übersprungen; ändern lassen sie sich in „Deine Auswahl“. */
  var KURZ = {
    wer: { damen: 'Damen', herren: 'Herren', kinder: 'Kinder', baby: 'Baby' },
    was: { pullover: 'Pullover', sweater: 'Pullover', cardigan: 'Cardigan', jacke: 'Cardigan', top: 'Top & Bluse', bluse: 'Top & Bluse', slipover: 'Slipover', pullunder: 'Slipover',
      muetze: 'Mütze & Stirnband', schal: 'Schal & Tuch', tuch: 'Schal & Tuch', socken: 'Socken & Handschuhe', handschuhe: 'Socken & Handschuhe', zuhause: 'Für Zuhause', decke: 'Für Zuhause' },
    // Wolle-Finder: ?finder=1&projekt=socken&staerke=dk
    projekt: { pullover: 'Pullover oder Jacke', jacke: 'Pullover oder Jacke', cardigan: 'Pullover oder Jacke', socken: 'Socken', sommer: 'Sommertop', sommertop: 'Sommertop', top: 'Sommertop',
      baby: 'Für Babys', babys: 'Für Babys', kinder: 'Kinderkleidung', muetze: 'Mütze und Schal', schal: 'Mütze und Schal', tuch: 'Tuch', decke: 'Decke', haekeln: 'Zum Häkeln' },
    sw: { anfang: 0, anfaenger: 0, etwas: 1, alles: 2 },
    welt: { herbst: 'warm' },
  };
  function vorauswahl(v, p) {
    var u = new URL(location.href), weiter = [], gesetzt = 0, vorab = [];
    REIHE.forEach(function (k) {
      var roh = (p.get(k) || '').toLowerCase().trim(); u.searchParams.delete(k);
      var s = schritt(v, k); if (!roh || !s) return;
      var kl = kacheln(s), titel = function (b) { return b.querySelector('b').textContent.trim(); }, treffer = [];
      if (k === 'sw') { var i = KURZ.sw[roh]; if (i !== undefined) treffer = [kl.filter(function (b) { return !b.hasAttribute('data-weiss'); })[i]].filter(Boolean); }
      else if (k === 'welt') { var w = FW && FW.schluessel(KURZ.welt[roh] || roh), l = w && FW.label(w); treffer = kl.filter(function (b) { return l && b.getAttribute('data-werte') === l; }); }
      else if (k === 'gr' || k === 'staerke') { treffer = kl.filter(function (b) { return titel(b).toLowerCase().replace(/ /g, '-') === roh.replace(/ /g, '-'); }); }
      else { var namen = roh.split(',').map(function (x) { return KURZ[k][x.trim()]; }).filter(Boolean); treffer = kl.filter(function (b) { return namen.indexOf(titel(b)) >= 0; }); }
      if (!treffer.length) return;
      gesetzt++; vorab.push(k);
      var werte = []; treffer.forEach(function (b) { werte = werte.concat((b.getAttribute('data-werte') || '').split('|').filter(Boolean)); });
      u.searchParams.delete(s.dataset.param);
      if (!werte.length) { weiter.push(k); return; } // „Ich stricke fast alles“ = ohne Filter, aber beantwortet
      werte.forEach(function (x) { u.searchParams.append(s.dataset.param, x); });
      if (k === 'welt' && FW) FW.merken(FW.schluessel(werte[0]));
    });
    u.searchParams.delete('finder'); u.searchParams.delete('page');
    return gesetzt ? { url: u.pathname + u.search, weiter: weiter, vorab: vorab } : null;
  }

  /* ── Zeichnen nach jedem Laden ── */
  var editVorlage = null; // beim Ändern einer Antwort: Vorlage, berechnet nur mit den Antworten davor
  function zeichnen() {
    var v = vorlage(); if (!v) return;
    REIHE = reiheVon(v);
    var z = lesen(), p = params();
    if (p.get('finder')) {
      var vor = vorauswahl(v, p);
      z = { offen: true, weiter: vor ? vor.weiter : [], wahl: [], genutzt: !!vor, vorab: vor ? vor.vorab : [] }; merken(z);
      if (vor) { laden(vor.url); return; } // Filter setzen, danach geht es bei der ersten offenen Frage weiter
      history.replaceState(history.state, '', urlOhne(location.href, ['finder'])); p = params();
    }
    var S = fragen(v);
    if (z.offen && bannerOffen()) { schliessen(); aufBannerWarten(); }
    else if (z.offen) {
      if (z.nur) {
        var s0 = schritt(editVorlage || v, z.nur);
        if (s0) zeigen(s0, 0, 1, true, z); else { z.offen = false; z.nur = null; merken(z); schliessen(); }
      } else {
        var keys = S.map(function (s) { return s.dataset.schritt; });
        var i = z.schritt ? keys.indexOf(z.schritt) : -1;
        if (i < 0) i = S.findIndex(function (s) { return !beantwortet(s, z); });
        if (i < 0) { z.offen = false; z.schritt = null; merken(z); schliessen(); setTimeout(ergebnis, 50); }
        else {
          // Fortschritt stabil halten: Die Größe zählt mit, solange sie noch kommen kann
          var wasP = paramVon('was');
          var grKommt = keys.indexOf('gr') < 0 && schritt(v, 'gr') && !(wasP && p.getAll(wasP).length) && (z.weiter || []).indexOf('was') < 0;
          if (S[i].dataset.schritt === 'was' && !z.wahlGesetzt) {
            z.wahl = kacheln(S[i]).filter(function (b) { return b.classList.contains('is-on'); }).map(function (b) { return b.getAttribute('data-werte'); });
            z.wahlGesetzt = true; merken(z);
          }
          // Fragen, die der Link schon beantwortet hat, zählen im Fortschritt nicht mit („1 von 4“ statt „1 von 5“)
          var offenS = S.filter(function (s) { return (z.vorab || []).indexOf(s.dataset.schritt) < 0; });
          zeigen(S[i], Math.max(0, offenS.indexOf(S[i])), offenS.length + (grKommt ? 1 : 0), false, z);
        }
      }
    } else schliessen();
    leiste(v, z);
    karten();
    garnKarten();
    verfuegbareZuerst();
    farbweltZeile();
  }
  function ergebnis() { var l = document.querySelector('[data-lfd-sum]:not([hidden])') || document.querySelector('.lfl__stat'); if (l) l.scrollIntoView({ block: 'center' }); }

  /* ── Antworten ── */
  function antworten(param, werte, k, ueberspringen) {
    var z = lesen(), u = new URL(location.href);
    u.searchParams.delete(param); u.searchParams.delete('page');
    werte.forEach(function (w) { if (w) u.searchParams.append(param, w); });
    z.weiter = (z.weiter || []).filter(function (x) { return x !== k; });
    if (ueberspringen) z.weiter.push(k);
    z.schritt = null; z.wahlGesetzt = false; z.genutzt = true;
    if (k === 'welt' && werte[0] && FW) FW.merken(FW.schluessel(werte[0]));
    merken(z);
    if (ebene) ebene.classList.add('is-laedt');
    laden(u.pathname + u.search);
  }
  function abschnitt(url) {
    var id = gridId(); var u = new URL(url, location.origin); u.searchParams.set('sections', id);
    return fetch(u.toString()).then(function (r) { return r.json(); }).then(function (t) {
      return new DOMParser().parseFromString(t[id], 'text/html').querySelector('[data-lfd-vorlage]');
    });
  }
  function anzahl(url) { return abschnitt(url).then(function (v) { return v ? +v.getAttribute('data-anzahl') : 0; }); }
  // Eine Antwort ändern: übrige behalten; passt danach nichts mehr, möglichst nur eine spätere Antwort weglassen
  function aendern(k, werte) {
    var z = lesen(), u = new URL(location.href), param = paramVon(k);
    u.searchParams.delete(param); u.searchParams.delete('page');
    werte.forEach(function (w) { if (w) u.searchParams.append(param, w); });
    if (k === 'welt' && werte[0] && FW) FW.merken(FW.schluessel(werte[0]));
    var spaeter = REIHE.slice(REIHE.indexOf(k) + 1).filter(function (x) { var pp = paramVon(x); return pp && u.searchParams.getAll(pp).length; });
    var gef = u.searchParams.getAll(GEF);
    if (ebene) ebene.classList.add('is-laedt');
    var ziel = u.pathname + u.search;
    anzahl(ziel).then(function (n) {
      if (n > 0 || (!spaeter.length && !gef.length)) return { url: ziel, weg: [] };
      var kandidaten = spaeter.slice().reverse().map(function (x) { return { param: paramVon(x), name: nameVon(x) }; });
      if (gef.length) kandidaten.unshift({ param: GEF, name: gef.join(', ').replace('Luftig für den Sommer', 'Für den Sommer') });
      var i = 0;
      // erst: reicht es, eine einzige Antwort wegzulassen? (die zuletzt gegebene zuerst)
      function einzeln() {
        if (i >= kandidaten.length) return vonHinten(0, ziel, []);
        var c = kandidaten[i++], url = urlOhne(ziel, [c.param]);
        return anzahl(url).then(function (m) { return m > 0 ? { url: url, weg: [c.name] } : einzeln(); });
      }
      // sonst: von hinten so viele weglassen wie nötig – die frühen Antworten bleiben
      function vonHinten(j, url, weg) {
        if (j >= kandidaten.length) return { url: url, weg: weg };
        var c = kandidaten[j], neu = urlOhne(url, [c.param]), weg2 = weg.concat([c.name]);
        return anzahl(neu).then(function (m) { return m > 0 ? { url: neu, weg: weg2 } : vonHinten(j + 1, neu, weg2); });
      }
      return einzeln();
    }).then(function (r) {
      z.nur = null; z.offen = false; z.wahlGesetzt = false; z.genutzt = true;
      z.hinweis = r.weg.length ? '„' + r.weg.join('“, „') + '“ ' + (r.weg.length === 1 ? 'passte nicht mehr dazu und ist weggefallen.' : 'passten nicht mehr dazu und sind weggefallen.') : null;
      merken(z); editVorlage = null;
      laden(r.url);
    });
  }

  /* ── „Deine Auswahl“ über dem Raster ── */
  function leiste(v, z) {
    var form = document.querySelector('[data-lianne-filterleiste]'), box = document.querySelector('[data-lfd-sum]');
    if (!form || !box) return;
    var p = params(), knoepfe = [];
    REIHE.forEach(function (k) {
      var s = schritt(v, k); if (!s || !p.getAll(s.dataset.param).length) return;
      knoepfe.push('<button type="button" class="lfdp" data-lfd-k="' + k + '">' + nameVon(k, v) + ' <svg width="9" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></button>');
    });
    var aktiv = knoepfe.length > 0;
    form.classList.toggle('lfl--finder', aktiv);
    // Ergebnisseite des Finders: Newsletter-Popup unterdrücken (CSS in lianne-kollektion.css)
    document.documentElement.classList.toggle('lfd-ergebnis', aktiv && !!z.genutzt);
    box.hidden = !aktiv;
    if (!aktiv) { box.innerHTML = ''; return; }
    // Weitere aktive Filter (Material, Marke, Preis …) gehören in dieselbe Zeile – eine Auswahl, ein Ort (Rückmeldung 08.10.2026)
    var finderParams = REIHE.map(paramVon).filter(Boolean);
    [].forEach.call(form.querySelectorAll('.lfl__stat .lfl__chip:not(.lfl__chip--link)'), function (c) {
      var pn = c.getAttribute('data-param') || '';
      if (finderParams.some(function (fp) { return pn === fp; })) return;
      knoepfe.push(c.outerHTML.replace('class="lfl__chip"', 'class="lfl__chip lfdp-chip"'));
    });
    // Ergebnis-Kopf nur nach echten Antworten im Finder, nicht beim Filtern von Hand (Testbericht A5)
    var anz = +v.getAttribute('data-anzahl');
    var kopf = z.genutzt ? '<h2 class="lfdp-kopf">' + SYMBOL + '<span>' + (anz === 0 ? 'Leider passt kein ' + wort(1) + ' genau' : anz === 1 ? 'Dein ' + wort(1) : 'Deine ' + anz + ' ' + wort(2)) + '</span></h2>' : '';
    box.innerHTML = kopf + '<div class="lfdp-leiste"><span class="lfdp-t">Deine Auswahl</span>' + knoepfe.join('') + '<button type="button" class="lfd__l" data-lfd-neu>Zurücksetzen</button></div>' +
      (z.hinweis ? '<p class="lfdp-hinweis" role="status">' + z.hinweis + '</p>' : '') + '<p class="lfdp-ausweg" hidden></p>';
    // Wolle-Finder: „Gut zu wissen“ zum gewählten Projekt (Wissen = Creme/Grün, nicht Lila)
    var tipp = v.querySelector('.lfdl-o.is-on[data-tipp]');
    if (tipp && tipp.getAttribute('data-tipp')) {
      var w = document.createElement('p'); w.className = 'lfdp-wissen';
      w.innerHTML = '<b>Gut zu wissen</b> '; w.appendChild(document.createTextNode(tipp.getAttribute('data-tipp')));
      box.appendChild(w);
    }
    if (z.hinweis) { z.hinweis = null; merken(z); }
    // Ausweg bei sehr wenigen Treffern: welche Antwort (außer „Für wen“) am meisten bringt, wenn sie wegfällt
    var n = +v.getAttribute('data-anzahl');
    var kandidaten = REIHE.filter(function (k) { return k !== 'wer' && paramVon(k) && p.getAll(paramVon(k)).length; });
    if (n <= 2 && kandidaten.length) {
      Promise.all(kandidaten.map(function (k) { return anzahl(urlOhne(location.href, [paramVon(k)])).then(function (m) { return { k: k, m: m }; }); })).then(function (r) {
        var best = r.filter(function (x) { return x.m > n; }).sort(function (a, b) { return b.m - a.m; })[0];
        var el = document.querySelector('.lfdp-ausweg'); if (!best || !el) return;
        el.innerHTML = (n === 0 ? 'Kein ' + wort(1) + ' passt' : n === 1 ? 'Nur 1 ' + wort(1) + ' passt' : 'Nur ' + n + ' ' + wort(2) + ' passen') + ' genau. Ohne „' + nameVon(best.k) + '“ wären es ' + best.m + '. <button type="button" class="lfd__l" data-lfd-ohne="' + best.k + '">Weglassen</button>';
        el.hidden = false;
      });
    }
  }

  /* ── Ergebnis: verfügbare Sets zuerst (nur die aktuelle Seite; Finder-Ergebnisse passen meist auf eine) ── */
  function verfuegbareZuerst() {
    if (!document.documentElement.classList.contains('lfd-ergebnis')) return;
    var nicht = [].filter.call(document.querySelectorAll('[data-lfd-karte][data-v="false"]'), function () { return true; });
    nicht.forEach(function (k) {
      var item = k.closest('li') || k.closest('.grid__item'); if (item && item.parentElement) item.parentElement.appendChild(item);
    });
  }

  /* ── Gemerkte Farbwelt: Knopf in der Filterleiste (10.10.2026, statt Textzeile „Deine Farbwelt … ändern vergessen“) ──
     Kein Shopify-Filter: färbt nur die Produktkarten. Ist die Farbwelt als Finder-Filter gesetzt, steht sie dort als Chip. */
  var PUNKTE = { natur: ['#D9D6CC', '#B5AD9C', '#8C8576'], warm: ['#A9725C', '#C98F45', '#7A4632'], kuehl: ['#4A6283', '#79A39A', '#3B7458'],
    zart: ['#F2DCDA', '#DCE7F0', '#F3EAC8'], kraeftig: ['#F24899', '#E89A2E', '#2F7ED8'], dunkel: ['#2B2B33', '#4C2238', '#1F3F3B'] };
  function punkte(k) { return '<span class="ss-welt__d">' + (PUNKTE[k] || []).map(function (c) { return '<i style="background:' + c + '"></i>'; }).join('') + '</span>'; }
  function farbweltZeile() {
    var d = document.querySelector('[data-lfd-welt-knopf]'); if (!d || !FW) return;
    var k = FW.gemerkt();
    d.hidden = !!params().get(WELT);
    if (d.hidden) return;
    var knopf = d.querySelector('summary');
    knopf.classList.toggle('is-on', !!k);
    knopf.innerHTML = k
      ? punkte(k) + FW.label(k) + '<span class="lfl__weg" role="button" tabindex="0" aria-label="Farbwelt entfernen" data-lfd-welt-weg>✕</span>'
      : 'Farbwelt<svg class="lfl__chev" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
    d.querySelector('[data-lfd-welt-wahl]').innerHTML = FW.WELTEN.map(function (w) {
      return '<button type="button" class="ss-welt' + (w[0] === k ? ' is-on' : '') + '" aria-pressed="' + (w[0] === k) + '" data-lfd-welt-setzen="' + w[0] + '">' + punkte(w[0]) + w[1] + '</button>';
    }).join('');
  }

  /* ── Produktkarten: Garnfarben der Farbwelt, Grund, Link mit Vorauswahl ── */
  var SW_TEXT = { 1: 'für Anfänger:innen', 2: 'für Anfänger:innen', 3: 'mit etwas Erfahrung', 4: 'für Fortgeschrittene', 5: 'für Fortgeschrittene' };
  function karten() {
    var p = params();
    var welt = p.get(WELT) || (FW && FW.gemerkt() ? FW.label(FW.gemerkt()) : null);
    var gr = p.get('filter.p.m.custom.finder_groessen');
    var finderAktiv = !!document.querySelector('[data-lianne-filterleiste].lfl--finder');
    // fd=1 (Messung) nur, wenn wirklich im Finder geantwortet wurde – nicht bei Filtern von Hand
    var ausFinder = finderAktiv && !!lesen().genutzt;
    var swParam = paramVon('sw');
    [].forEach.call(document.querySelectorAll('[data-lfd-karte]'), function (k) {
      var daten; try { daten = JSON.parse(k.querySelector('script').textContent); } catch (e) { return; }
      var karte = k.closest('.card-wrapper') || k.parentElement;
      var w = welt && daten.w && daten.w[welt];
      var html = '';
      // Farbfelder aus den Farbcodes (wie auf der Produktseite); ältere Daten ohne Farbcodes zeigen das Garnfoto
      if (w && w.h && w.h.length) html += '<span class="lfd-k__farben" title="In Deiner Farbwelt">' + w.h.map(function (hx) { return '<i style="background:' + hx + '"></i>'; }).join('') + '</span>';
      else if (w && w.i && w.i.length) html += '<span class="lfd-k__farben" title="In Deiner Farbwelt">' + w.i.map(function (src) { return '<img src="' + src + '" alt="" loading="lazy" width="22" height="22">'; }).join('') + '</span>';
      var gruende = [];
      if (finderAktiv) {
        if (swParam && p.get(swParam) && SW_TEXT[k.dataset.s]) gruende.push(SW_TEXT[k.dataset.s]);
        // „in M“ nur bei Sets mit eigener Größe – Mützen, Schals usw. passen jeder Größe
        if (gr && daten.g && daten.g.some(function (x) { return x.s && x.s.indexOf(gr) >= 0; })) gruende.push('in ' + gr);
        p.getAll(GEF).forEach(function (x) { gruende.push(x === 'Luftig für den Sommer' ? 'für den Sommer' : x.toLowerCase()); });
      }
      if (gruende.length) html += '<span class="lfd-k__warum">' + SYMBOL + '<span>' + gruende.join(' · ') + '</span></span>';
      k.innerHTML = '<script type="application/json">' + JSON.stringify(daten).replace(/</g, '\\u003c') + '</script>' + html;
      k.hidden = !html;
      var q = new URLSearchParams();
      if (gr && daten.g) { var g = daten.g.filter(function (x) { return x.s.indexOf(gr) >= 0; })[0]; if (g) q.set('groesse', g.n); }
      if (welt) q.set('welt', welt); // auch ohne Vorschaudaten – die Produktseite prüft selbst, ob es die Welt gibt
      if (ausFinder) q.set('fd', '1');
      links(karte, q);
    });
  }
  // Produktlinks einer Karte: Ursprung merken, Zusatz-Parameter anhängen (oder wieder entfernen)
  function links(karte, q) {
    [].forEach.call(karte.querySelectorAll('a[href*="/products/"]'), function (a) {
      if (!a.dataset.lfdUrsprung) a.dataset.lfdUrsprung = a.getAttribute('href');
      var basis = a.dataset.lfdUrsprung;
      a.setAttribute('href', q.toString() ? basis + (basis.indexOf('?') >= 0 ? '&' : '?') + q.toString() : basis);
    });
  }

  /* ── Wolle-Finder: „Nicht pflegeleicht“ auf der Karte (Julian 27.10.2026) ──
     Nur bei Projekten, für die oft gewaschen wird; Wissen = Creme/Grün. Wert aus custom.garn_charakter (1–5). */
  var PFLEGE_PROJEKTE = ['Für Babys', 'Kinderkleidung', 'Decke'];
  function garnKarten() {
    var pp = paramVon('projekt'), gewaehlt = pp ? params().getAll(pp) : [];
    var zeigen = gewaehlt.some(function (x) { return PFLEGE_PROJEKTE.indexOf(x) >= 0; });
    // fd=1 (Messung, „‹ Deine Auswahl“ auf der Garnseite) wie bei den Sets nur nach echten Antworten (28.10.2026)
    var q = new URLSearchParams();
    if (document.querySelector('[data-lianne-filterleiste].lfl--finder') && lesen().genutzt) q.set('fd', '1');
    [].forEach.call(document.querySelectorAll('[data-lfd-garn]'), function (k) {
      var an = zeigen && +k.getAttribute('data-pf') < 4;
      if (an && !k.firstChild) k.innerHTML = '<span class="lfd-k__wissen">Nicht pflegeleicht</span>';
      k.hidden = !an;
      links(k.closest('.card-wrapper') || k.parentElement, q);
    });
  }
  // „Mehr anzeigen“ hängt Karten ohne collection:reloaded an – neue Karten deshalb beobachten
  var garnTimer = null;
  if (document.querySelector('[data-lfd-garn]') || (vorlage() && reiheVon(vorlage()).indexOf('projekt') >= 0)) {
    new MutationObserver(function () { clearTimeout(garnTimer); garnTimer = setTimeout(garnKarten, 60); }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── Klicks ── */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('[data-lfd-welt-weg]')) { e.preventDefault(); e.target.click(); }
  });
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-lfd-auf]'))) { e.preventDefault(); merken({ offen: true, weiter: [], wahl: [] }); editVorlage = null; zeichnen(); return; }
    if (t.closest('a[href*="/products/"]') && document.querySelector('.lfl--finder')) { try { sessionStorage.setItem('lfd-zurueck', location.href); } catch (x) {} }
    if ((el = t.closest('[data-lfd-welt-setzen]'))) { FW.merken(el.getAttribute('data-lfd-welt-setzen')); el.closest('details').open = false; farbweltZeile(); karten(); return; }
    if (t.closest('[data-lfd-welt-weg]')) { e.preventDefault(); FW.merken(null); var dd = t.closest('details'); if (dd) dd.open = false; farbweltZeile(); karten(); return; }
    if ((el = t.closest('[data-lfd-k]'))) { // eine Antwort ändern
      var k = el.getAttribute('data-lfd-k'), z = lesen(); z.offen = true; z.nur = k;
      var abK = REIHE.slice(REIHE.indexOf(k)).map(paramVon).filter(Boolean);
      var s = schritt(vorlage(), k);
      z.wahl = s ? kacheln(s).filter(function (b) { return b.classList.contains('is-on'); }).map(function (b) { return b.getAttribute('data-werte'); }) : [];
      z.wahlGesetzt = true; merken(z);
      ebeneBauen().classList.add('is-laedt'); oeffnen();
      abschnitt(urlOhne(location.href, abK)).then(function (alt) {
        editVorlage = alt;
        var s2 = schritt(alt, k), aktuell = params().getAll(paramVon(k));
        if (s2) kacheln(s2).forEach(function (b) { var w = (b.getAttribute('data-werte') || '').split('|'); b.classList.toggle('is-on', w[0] !== '' && w.every(function (x) { return aktuell.indexOf(x) >= 0; })); });
        zeichnen();
      });
      return;
    }
    if ((el = t.closest('[data-lfd-weg]'))) { var u = new URL(location.href), rest = u.searchParams.getAll(GEF).filter(function (x) { return x !== el.getAttribute('data-lfd-weg'); }); u.searchParams.delete(GEF); rest.forEach(function (x) { u.searchParams.append(GEF, x); }); laden(u.pathname + u.search); return; }
    if ((el = t.closest('[data-lfd-ohne]'))) { laden(urlOhne(location.href, [paramVon(el.getAttribute('data-lfd-ohne'))])); return; }
    if (t.closest('[data-lfd-neu]')) {
      // alles entfernen, was in „Deine Auswahl“ steht; neu beginnen geht über den Einstieg im Kopf (Rückmeldung 07./08.10.2026)
      merken({ offen: false, weiter: [], wahl: [] }); editVorlage = null;
      var u = new URL(location.href);
      Array.from(u.searchParams.keys()).filter(function (k) { return k.indexOf('filter.') === 0; }).forEach(function (k) { u.searchParams.delete(k); });
      laden(u.toString()); return;
    }
    if (ebene && t === ebene) { var z0 = lesen(); z0.offen = false; z0.nur = null; merken(z0); editVorlage = null; schliessen(); return; }
    if (!ebene || !ebene.contains(t)) return;
    var zz = lesen(), inhalt = ebene.querySelector('.lfdl-in'), kk = inhalt.getAttribute('data-schritt'), param = inhalt.getAttribute('data-param');
    if (t.closest('[data-lfdl-zu]')) { zz.offen = false; zz.nur = null; merken(zz); editVorlage = null; schliessen(); return; }
    if (t.closest('[data-lfdl-zurueck]')) {
      var keys = fragen(vorlage()).map(function (s) { return s.dataset.schritt; }).filter(function (k) { return (zz.vorab || []).indexOf(k) < 0; }), i = keys.indexOf(kk);
      zz.schritt = keys[Math.max(0, i - 1)]; zz.wahlGesetzt = false; merken(zz); zeichnen(); return;
    }
    if (t.closest('[data-lfdl-weiter]')) {
      var werte = []; (zz.wahl || []).forEach(function (w) { werte = werte.concat(w.split('|')); });
      if (zz.nur) aendern(kk, werte); else antworten(param, werte, kk); return;
    }
    if (t.closest('[data-weiss]')) {
      if (zz.nur) { aendern(kk, []); return; }
      if (params().getAll(param).length) { antworten(param, [], kk, true); return; }
      zz.weiter = (zz.weiter || []).concat(kk); zz.schritt = null; zz.wahlGesetzt = false; merken(zz); zeichnen(); return;
    }
    if ((el = t.closest('.lfdl-o'))) {
      var w2 = el.getAttribute('data-werte') || '';
      if (inhalt.querySelector('.lfdl-opts--bild')) { // „Was“: Mehrfachauswahl
        zz.wahl = zz.wahl || []; var j = zz.wahl.indexOf(w2); if (j >= 0) zz.wahl.splice(j, 1); else zz.wahl.push(w2);
        merken(zz); wahlZeigen(inhalt, zz.wahl); return; // nur Markierung + „Weiter“ – kein Neuaufbau, sonst laden die Bilder neu
      }
      var liste = w2 ? w2.split('|') : [];
      if (zz.nur) aendern(kk, liste); else antworten(param, liste, kk, el.hasAttribute('data-alle'));
    }
  });
  document.addEventListener('change', function (e) {
    var cb = e.target; if (!ebene || !ebene.contains(cb) || cb.type !== 'checkbox') return;
    var z = lesen(), u = new URL(location.href), werte = u.searchParams.getAll(GEF).filter(function (x) { return x !== cb.value; });
    if (cb.checked) werte.push(cb.value);
    u.searchParams.delete(GEF); u.searchParams.delete('page'); werte.forEach(function (x) { u.searchParams.append(GEF, x); });
    z.schritt = z.nur ? z.schritt : 'welt'; merken(z); ebene.classList.add('is-laedt'); laden(u.pathname + u.search);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ebene && !ebene.hidden) { var z = lesen(); z.offen = false; z.nur = null; merken(z); editVorlage = null; schliessen(); }
  });

  document.addEventListener('collection:reloaded', zeichnen);
  window.addEventListener('popstate', function () { setTimeout(zeichnen, 0); });
  // Beim Aufruf der Seite öffnet sich die Ebene nur über ?finder=1 (Menü, Startseite, alte Studio-Adresse) –
  // ein „offen“ aus einem früheren Besuch wird verworfen
  var bannerWache = 0;
  function bannerBeobachten() {
    var t = setInterval(function () {
      if (++bannerWache > 40) { clearInterval(t); return; } // die ersten ~20 s nach dem Laden
      if (ebene && !ebene.hidden && bannerOffen()) { schliessen(); aufBannerWarten(); }
    }, 500);
  }
  function start() { bannerBeobachten(); var z = lesen(); if (z.offen || z.nur) { z.offen = false; z.nur = null; merken(z); } zeichnen(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
